import { render, staticRenderFns } from "./ota-create.vue?vue&type=template&id=7ff1182d&scoped=true&"
import script from "./ota-create.vue?vue&type=script&lang=tsx&"
export * from "./ota-create.vue?vue&type=script&lang=tsx&"
import style0 from "./ota-create.vue?vue&type=style&index=0&id=7ff1182d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff1182d",
  null
  
)

export default component.exports